import Vue from 'vue'
import App from './App.vue'
import './filters'
import router from "./router"
import '../public/js/flexble.js'
import store from './store';
import { Capacitor } from '@capacitor/core';
import { StatusBar } from '@capacitor/status-bar';
import { Device } from '@capacitor/device';

import './assets/css/reset.css';
import 'vant/lib/index.less';
import './styles/global.scss';

// iOS分享兼容性修复
// import { IOSShareFix } from '@/utils/iosShareFix';
// 页面标题管理工具
import titleManager from '@/utils/titleManager';
// Android 性能优化
// import { androidPerformanceOptimizer } from '@/utils/androidPerformanceOptimizer';

// import eventLib from '@/utils/documentEvent.js';
// window.$_EventLib = eventLib;
// 滑动验证
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);
//音视频播放
import VideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
import "vue-video-player/src/custom-theme.css";

Vue.use(VideoPlayer)

import AlleyUI from "./lib"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


import Vant from 'vant';
import 'vant/lib/index.css';
import 'vant/lib/index.less';
import { Toast } from 'vant'
Vue.use(Toast)
Vue.use(Vant);
Vue.use(AlleyUI);
Vue.use(titleManager);
// 引入环境检测插件
import { EnvPlugin } from '@/utils/env-detector'
// 使用插件
Vue.use(EnvPlugin)


// 裁切
import VueCropper from "vue-cropper";
Vue.use(VueCropper);
// 滑片
import "swiper/css/swiper.min.css"
import { swiper, swiperSlide } from 'vue-awesome-swiper';
Vue.component('Swiper', swiper);
Vue.component('SwiperSlide', swiperSlide);
// 瀑布流
import VueMasonry from 'vue-masonry-css'
Vue.use(VueMasonry)

import globalMixin from '../src/mixins/lineHeightMixin.js';
Vue.mixin(globalMixin); // 引入全局混入

import global from '@/mixins/index.js'
Vue.mixin(global)
import wx from 'weixin-js-sdk';
// Push 初始化暂时禁用（iOS JPush 未配置时会导致链接/运行错误）
// import { initPush } from '@/utils/push';
import authService from '@/utils/authService';

Vue.prototype.$wx = wx;

// 将iOS分享修复工具添加到Vue原型中
// Vue.prototype.$IOSShareFix = IOSShareFix;

// 在这里添加全局变量
Vue.prototype.$globalCloseImage = require('@/assets/image/closeIcon.png');

// Vue.directive('line-height', lineHeightDirective);

// import Vconsole from 'vconsole'; //移动端调试工具
//   // 打包后隐藏
// if (process.env.NODE_ENV == 'development') {
//   const vConsole = new Vconsole();
//   Vue.use(vConsole);
// }

// 创建事件总线
Vue.prototype.bus = new Vue()

Vue.config.productionTip = false
// 原生环境适配：添加 body 标记并兜底设置 StatusBar overlay
try {
  if (typeof Capacitor !== 'undefined' && Capacitor.isNativePlatform && Capacitor.isNativePlatform()) {
    document.body.classList.add('capacitor-app');
    const ua = navigator.userAgent || '';
    const isiOS = /iP(hone|od|ad)/.test(ua);
    // 兜底设置：iOS 使用 overlay 以配合 safe-area，Android 通常不 overlay 避免遮挡
    if (isiOS) {
      StatusBar.setOverlaysWebView({ overlay: true }).catch(()=>{});
    } else {
      StatusBar.setOverlaysWebView({ overlay: false }).catch(()=>{});
    }
    // 强制设置样式与背景色（使用透明以避免部分机型出现覆盖问题）
    try {
      StatusBar.setStyle({ style: 'DARK' }).catch(()=>{});
      StatusBar.setBackgroundColor({ color: 'transparent' }).catch(()=>{});
    } catch (err) {
      console.warn('[Capacitor] StatusBar setStyle/setBackgroundColor failed', err);
    }
    // 使用 Device 插件进一步识别机型（如 Mi 15 Ultra），对部分小米机型强制开启 safe-area
    (async function applyDeviceSpecificFixes() {
      try {
        if (typeof Device !== 'undefined' && Device.getInfo) {
          const info = await Device.getInfo();
          const manufacturer = (info.manufacturer || '') + '';
          const model = (info.model || '') + '';
          const combined = (manufacturer + ' ' + model).toLowerCase();
          const isXiaomi = /xiaomi|redmi|mi(?!cro)/i.test(combined);
          const isMi15Ultra = /15\s*ultra|mi\s*15\s*ultra/i.test(combined);

          // 动态检测：优先使用 env()（通过临时元素读取），若为 0 再询问 StatusBar.getInfo()
          try {
            const tmp = document.createElement('div');
            tmp.style.cssText = 'position:absolute;top:-9999px;padding-top:env(safe-area-inset-top);';
            document.body.appendChild(tmp);
            const tmpPx = parseFloat(getComputedStyle(tmp).paddingTop) || 0;
            document.body.removeChild(tmp);
            let statusBarHeight = 0;
            try {
              const sbInfo = await StatusBar.getInfo();
              statusBarHeight = (sbInfo && sbInfo.height) ? Number(sbInfo.height) : 0;
            } catch (e) {
              // ignore if API not available
            }

            console.log('[safe-area-debug] device detection tmpPx:', tmpPx, 'statusBarHeight:', statusBarHeight, 'isXiaomi:', isXiaomi, 'isMi15Ultra:', isMi15Ultra);
            // 设置全局 CSS 变量，供组件使用（默认单位为 px）
            try {
              const insetValue = tmpPx > 0 ? tmpPx : (statusBarHeight > 0 ? statusBarHeight : 0);
              document.documentElement.style.setProperty('--xpz-safe-inset-top', `${insetValue}px`);
              // 同步一个 header + inset 的偏移变量，若需要可直接使用
              document.documentElement.style.setProperty('--xpz-header-offset', `${48 + insetValue}px`);
            } catch (e) {
              // ignore
            }

            // 如果系统真正提供了 safe-area（tmpPx > 0 或 statusBarHeight > 0），则在 iOS 上标记需要 safe-area（但不强制 body padding）
            if (tmpPx > 0 || statusBarHeight > 0) {
              if (isiOS) {
                document.body.classList.add('need-safe-area');
              }
            } else {
              // 否则（系统没给值），仅在品牌极端情况下作为兜底处理：对小米/特定机型再强制加 padding 以避免遮挡
              if (isMi15Ultra || isXiaomi) {
                document.body.classList.add('need-safe-area');
                try {
                  document.body.style.paddingTop = "calc(env(safe-area-inset-top) + 24px)";
                  try {
                    StatusBar.setBackgroundColor({ color: 'transparent' }).catch(()=>{});
                    StatusBar.setStyle({ style: 'DARK' }).catch(()=>{});
                  } catch (err) {
                    console.warn('[Capacitor] StatusBar setBackgroundColor/style failed for Xiaomi', err);
                  }
                } catch (err) {
                  console.warn('[MiFix] apply padding failed', err);
                }
              } else {
                // 不做额外操作，保留默认（用于 emulator 或其他真实不需要 safe-area 的设备）
              }
            }
          } catch (err) {
            console.warn('[Device] safe-area dynamic detection failed', err);
          }
        }
      } catch (err) {
        console.warn('[Device] getInfo failed', err);
      }
    })();
  }
} catch (e) {
  console.warn('[Capacitor] statusbar setup error', e);
}

// 运行时检测：判断是否需要为当前设备应用安全区顶部 padding
function detectAndApplySafeArea() {
  try {
    if (typeof window === 'undefined') return;

    // CSS env 支持检测
    const supportsEnv = typeof window.CSS !== 'undefined' && window.CSS.supports && window.CSS.supports('padding-top: env(safe-area-inset-top)');

    // 视口高度比 outer/屏幕高度小时，往往表示存在状态栏或刘海（只是 heuristic）
    const hasNotchViewport = window.innerHeight < (window.outerHeight || screen.height);

    const ua = navigator.userAgent || '';
    const isiOS = /iP(hone|od|ad)/.test(ua);
    const isXiaomi = /Mi|XiaoMi|Xiaomi|Redmi/i.test(ua);

    // Debug logs (only in native)
    if (typeof Capacitor !== 'undefined' && Capacitor.isNativePlatform && Capacitor.isNativePlatform()) {
      try {
        console.log('[safe-area-debug] supportsEnv:', supportsEnv, 'hasNotchViewport:', hasNotchViewport, 'ua:', ua);
        console.log('[safe-area-debug] isiOS:', isiOS, 'isXiaomi:', isXiaomi);
        const tmp = document.createElement('div');
        tmp.style.cssText = 'position:absolute;top:-9999px;padding-top:env(safe-area-inset-top);';
        document.body.appendChild(tmp);
        const tmpVal = getComputedStyle(tmp).paddingTop;
        console.log('[safe-area-debug] env(safe-area-inset-top) via temp element:', tmpVal);
        document.body.removeChild(tmp);
        const appEl = document.getElementById('app');
        console.log('[safe-area-debug] current #app paddingTop:', appEl ? getComputedStyle(appEl).paddingTop : getComputedStyle(document.body).paddingTop);
      } catch (e) {
        console.warn('[safe-area-debug] logging failed', e);
      }
    }

    // 小米/Redmi 机型在许多情况下需要强制启用 safe-area
    if (isXiaomi) {
      document.body.classList.add('need-safe-area');
      return;
    }

    // 启用 safe-area：优先用 env() 检测；若不支持 env，但视口高度表现出刘海（hasNotchViewport），也在 iOS 上启用
    if (isiOS && (supportsEnv || hasNotchViewport)) {
      document.body.classList.add('need-safe-area');
    } else {
      document.body.classList.remove('need-safe-area');
    }
  } catch (err) {
    // ignore
  }
}

// 立即运行一次并在窗口尺寸变更时再次判断
try {
  detectAndApplySafeArea();
  window.addEventListener('resize', detectAndApplySafeArea);
  window.addEventListener('orientationchange', detectAndApplySafeArea);
} catch (e) {
  console.warn('[safe-area] detectAndApplySafeArea setup error', e);
}

new Vue({
  router,
  store,
  render: h => h(App),
  async   mounted() {
    // 应用启动时进行iOS优化
    // IOSShareFix.optimizeForIOS();

    // 只在原生App中启用自动登录
    if (authService.isAutoLoginEnabled()) {
      // 尝试自动登录
      try {
        const autoLoginSuccess = await authService.tryAutoLogin();
        if (autoLoginSuccess) {
          console.log('[AutoLogin] 自动登录成功');
          try {
            console.log('[AutoLogin] post-login location:', window.location.href, window.location.hash);
            console.log('[AutoLogin] post-login localStorage xpzAuthData:', localStorage.getItem('xpzAuthData'));
            console.log('[AutoLogin] post-login sessionStorage userInfoXpz:', sessionStorage.getItem('userInfoXpz'));
          } catch (e) {
            console.warn('[AutoLogin] post-login inspect failed:', e);
          }

          // 如果当前是登录页或根路径，自动导航到角色对应首页（冷启动场景）
          try {
            const userInfo = authService.getUserInfo() || {};
            const accountType = userInfo.accountType || authService.getAccountType();
            const currentHash = (window.location.hash || '').replace(/^#/, '');

            // Only attempt redirect when at root or login pages
            if (!currentHash || currentHash === '/' || currentHash.startsWith('/login') || currentHash.startsWith('/verifyLogin')) {
              // helper to try SPA navigation
              const trySpaNavigate = async (path) => {
                try {
                  await Vue.nextTick();
                  // small delay to reduce race conditions
                  await new Promise(r => setTimeout(r, 30));
                  await this.$router.replace({ path });
                  return true;
                } catch (err) {
                  return false;
                }
              };

              if (accountType === 6) {
                console.log('[AutoLogin] attempting SPA navigate to /replenishment');
                const ok = await trySpaNavigate('/replenishment');
                if (!ok) {
                  console.warn('[AutoLogin] SPA navigate failed, falling back to hard redirect');
                  window.location.href = window.location.origin + '/#/replenishment';
                }
              } else if (accountType) {
                console.log('[AutoLogin] attempting SPA navigate to /initPage for accountType', accountType);
                const ok = await trySpaNavigate('/initPage');
                if (!ok) {
                  console.warn('[AutoLogin] SPA navigate failed, falling back to hard redirect to /initPage');
                  window.location.href = window.location.origin + '/#/initPage';
                }
              }
            } else {
              console.log('[AutoLogin] currentHash not root/login, skipping auto-redirect:', currentHash);
            }
          } catch (e) {
            console.warn('[AutoLogin] auto-redirect failed:', e);
          }
        } else {
          console.log('[AutoLogin] 自动登录失败，用户需要手动登录');
        }
      } catch (error) {
        console.error('[AutoLogin] 自动登录过程中发生错误:', error);
      }
    } else {
      console.log('[AutoLogin] 免登功能仅在原生App中启用，当前为浏览器环境');
    }

    // 初始化推送服务
    // 说明：
    // - 首次启动且用户尚未同意隐私政策时，不初始化推送，避免在同意前获取设备标识（如 ANDROID_ID）
    // - 如果用户之前已经同意过隐私政策（本地有标记），则可以在启动时直接初始化推送
    // - 用户首次同意隐私政策时，会在 App.vue 的 handleAgree 中再次调用 initPush
    try {
      let hasAgreed = false;
      try {
        if (typeof localStorage !== 'undefined') {
          hasAgreed = localStorage.getItem('privacyAgreementAgreed') === 'true';
        }
      } catch (e) {
        console.warn('[Main] Failed to read privacy agreement state, treat as not agreed:', e);
      }

      if (hasAgreed) {
        const { initPush } = await import('@/utils/push');
        await initPush();
        console.log('[Main] Push service initialized successfully (user had agreed privacy policy)');
      } else {
        console.log('[Main] User has not agreed privacy policy yet, skip push initialization on startup');
      }
    } catch (e) {
      console.warn('[Main] Push init failed (expected in emulator or before agreement):', e);
    }

    // 初始化 Android 性能优化
    // androidPerformanceOptimizer.init();

    // 注销已存在的 Service Worker
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        for (let registration of registrations) {
          registration.unregister().then(success => {
            if (success) {
              console.log('[SW] Service Worker 已注销');
            }
          });
        }
      });
    }
  }
}).$mount('#app')
